/** Opens the selected source file in the case's document view. */
export function documentPath(caseId: string, documentId: string): string {
  return `/cases/${caseId}/documents?doc=${encodeURIComponent(documentId)}`
}
